'use client';

import { FC, ReactNode } from 'react';

import { EmptyNavigation } from '@telialt/core-navigation/src/components/EmptyNavigation';

import { BranchInfoFooter } from './BranchInfoFooter';
import { Footer } from './Footer';
import { NavBar } from './NavBar';

type Props = {
    dataTest?: string;
    hasEmptyNavBar?: boolean;
    hideFooter?: boolean;
    children: ReactNode;
};

export const Layout: FC<Props> = ({ dataTest, hasEmptyNavBar, hideFooter, children }) => {
    return (
        <div data-test={dataTest}>
            {hasEmptyNavBar ? <EmptyNavigation /> : <NavBar />}
            <main id="main-content">{children}</main>
            {!hideFooter && <Footer />}
            <BranchInfoFooter />
        </div>
    );
};
